import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'ai-agent',
  name: 'AI Agent',
  category: 'ai-nodes',
  description: 'AI agent with tool calling, memory, and conversation management. Connect sub-nodes for model, memory, and tools.',
  icon: 'Bot',
  color: 'purple',
  version: '2.0.0', // Major version bump for sub-node architecture
  
  group: ['ai', 'agent'],
  
  defaults: {
    name: 'AI Agent',
    color: 'purple' // Use Tailwind color name
  },
  
  subtitle: 'Connect model, memory, and tools',
  
  // No credentials needed - sub-nodes handle their own credentials
  credentials: [],
  
  inputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  // NEW: Define anchors for sub-node connections
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Model',
        multiple: false,
        acceptTypes: ['anthropic', 'openai']
      },
      {
        type: 'subNode',
        subNodeCategory: 'memory',
        label: 'Memory',
        multiple: false,
        acceptTypes: ['simpleMemory', 'vectorMemory', 'bufferMemory']
      },
      {
        type: 'subNode',
        subNodeCategory: 'tool',
        label: 'Tools',
        multiple: true,
        acceptTypes: ['*'] // Accept any tool-capable node
      },
      {
        type: 'subNode',
        subNodeCategory: 'parser',
        label: 'Parser',
        multiple: false,
        acceptTypes: ['agentOutputParser']
      }
    ]
  },
  
  tags: ['ai', 'agent', 'llm', 'chat', 'assistant', 'tools', 'langchain'],
  
  comingSoon: false
};

export default definition;
